/**
 * ListingsSkeleton
 * 
 * @Author: Focci
 * @Date: 2023-08-02 20:49:29
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-02 20:49:29
 */

import PropTypes from 'prop-types'
import { times } from 'lodash-es'
import { VerticalCardSkeleton } from '@page/common/card/property/CardSkeleton'

export default function ListingsSkeleton({
  count = 8,
  coverClassName
}) {
  return times(count).map((key) => (
    <VerticalCardSkeleton key={key} coverClassName={coverClassName} />
  ))
}

ListingsSkeleton.propTypes = {
  count: PropTypes.number,
}
